import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ce2e24c8: FaireBrandEntity = {
  token: "b_ce2e24c8",
  type: "brand",
  name: "Good Luck Sock",
  avatarUrl:
    "https://cdn.faire.com/fastly/929cf8c7efc5f264ed748e0818e2cb44daaaa16a1f1e8bd1d2da4cc7a667db84.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ed685c5ec68a8bb84d1a1c4ec1aaf6ec33fec72f470b8426e847f61038744fe2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/929cf8c7efc5f264ed748e0818e2cb44daaaa16a1f1e8bd1d2da4cc7a667db84.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ed685c5ec68a8bb84d1a1c4ec1aaf6ec33fec72f470b8426e847f61038744fe2.jpeg",
  location: "AB, CAN",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 476,
  isTopShop: true,
  isInsider: false,
  description:
    "Please note that all orders are DUTY & TARIFF FREE within North America (United States + Canada). The final price on your invoice is the only cost you'll ever see — making it simple, transparent, and risk-free to do business with us. Faire may display a message at checkout that duty or tariffs \"may be owing\". This is not the case. We're working with Faire to resolve this messaging issue. You will never be charged any duty or tariffs if you order from Good Luck Sock!\n\nGood Luck Sock carries over over 1,000 uniquely awesome, cool, colorful, crazy and fun socks, underwear and pajamas for men, women and kids. Checkout our officially licensed merchandise from brands like; The Rolling Stones, Trailer Park Boys, Bob Ross, Barbie, The Princess Bride, KISS, Mötley Crüe, Elton John, Cheech & Chong, Rambo and more!\n\nAll orders are shipped out within 1 business day of being received and usually take between 1-5 business days to arrive. We ship to United States (FedEx) and Canada (Canada Post) using local carriers so that there are no additional cross-border charges.\n\n3rd party marketplace resellers (such as Amazon, Jet, eBay, Poshmark, Etsy) are not eligible to purchase products on Faire.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:15.661Z",
    importedBy: "entity-db-cli",
  },
};
